





















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { jinroPlayerGameDocument } from "@/services/datatypes";
import { db } from "@/scripts/firebase";
import { JinroRoles } from "../../services/jinro-roles";
import { HowToBeKilled } from "../../services/how-to-be-killed";

@Component({})
export default class JinroPlayerGameInfo extends Vue {
  @Prop() readonly jinroGameId!: string;
  jinroPlayerGameInfo: jinroPlayerGameDocument | null = null;
  detacher?: firebase.Unsubscribe;

  get playerRole(): string {
    if (this.jinroPlayerGameInfo) {
      return this.jinroPlayerGameInfo.role;
    }
    return "";
  }

  get playerIsKilled(): boolean {
    if (this.jinroPlayerGameInfo) {
      return !!this.jinroPlayerGameInfo.isKilled;
    }
    return false;
  }

  get howToBeKilledIcon(): string {
    if (!this.jinroPlayerGameInfo) {
      return "";
    }
    if (this.jinroPlayerGameInfo.howToBeKilled === HowToBeKilled.JinroAttack) {
      return "fas fa-dog";
    }
    if (this.jinroPlayerGameInfo.howToBeKilled === HowToBeKilled.Execution) {
      return "fas fa-vote-yea";
    }

    return "";
  }

  get howToBeKilledLabel(): string {
    if (!this.jinroPlayerGameInfo) {
      return "";
    }
    if (this.jinroPlayerGameInfo.howToBeKilled === HowToBeKilled.JinroAttack) {
      return "噛";
    }
    if (this.jinroPlayerGameInfo.howToBeKilled === HowToBeKilled.Execution) {
      return "投票";
    }

    return "";
  }

  get tagTypeForPlayRole(): string {
    if (
      this.playerRole === JinroRoles.Jinro ||
      this.playerRole === JinroRoles.Kyojin
    ) {
      return "is-dark";
    }
    return "is-primary";
  }

  async created() {
    this.onSnapJinroPlayInfo();
  }

  @Watch("jinroGameId")
  onChange() {
    this.onSnapJinroPlayInfo();
  }

  onSnapJinroPlayInfo() {
    this.detacher = this.refJinroPlayerGame.onSnapshot(snapshot => {
      this.jinroPlayerGameInfo = snapshot.data() as jinroPlayerGameDocument;
      this.$store.commit("setJinroPlayerGame", this.jinroPlayerGameInfo);
    });
  }

  get refJinroPlayerGame(): firebase.firestore.DocumentReference {
    return db.doc(
      `jinroplayers/${this.$route.params.jinroPlayerId}/jinrogames/${this.jinroGameId}`
    );
  }
  destroyed() {
    this.detacher && this.detacher();
  }
}
